// extracted by mini-css-extract-plugin
export default {"app_lateral_menu":"style_app_lateral_menu__23WDS"};